<div class="login-wrapper">
    <!-- ============================================
         OPTION 3: MINIMAL ELEGANT SPLASH SCREEN
         Guaranteed 18-second display with feature carousel
         ============================================ -->
    <div class="auto-setup-overlay" *ngIf="isAutoSetupInProgress">
        <div class="minimal-splash">

            <!-- Subtle Background Gradient -->
            <div class="bg-mesh"></div>

            <!-- Main Content -->
            <div class="splash-content">

                <!-- Breathing Logo -->
                <div class="breathing-logo">
                    <div class="breath-ring ring-1"></div>
                    <div class="breath-ring ring-2"></div>
                    <div class="breath-ring ring-3"></div>
                    <div class="logo-center">
                        <svg width="64" height="64" viewBox="0 0 80 80" fill="none">
                            <rect width="80" height="80" rx="18" fill="#f97316" />
                            <path d="M25 18V62H55" stroke="white" stroke-width="6" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="25" cy="18" r="5" fill="white" />
                            <circle cx="55" cy="62" r="5" fill="white" />
                        </svg>
                    </div>
                </div>

                <!-- Welcome Message -->
                <div class="welcome-block">
                    <h1>Welcome to <span class="brand-name">LIAM</span></h1>
                    <p class="subtitle">Longitudinal Intelligent Agentic Memory</p>
                </div>

                <!-- Feature Highlights (rotating carousel) -->
                <div class="feature-carousel">
                    <div class="feature-item" [class.visible]="currentFeature === 0">
                        <i class="fa fa-brain"></i>
                        <span>Store unlimited memories</span>
                    </div>
                    <div class="feature-item" [class.visible]="currentFeature === 1">
                        <i class="fa fa-comments"></i>
                        <span>Access via ChatGPT, Claude AI &amp; Perplexity</span>
                    </div>
                    <div class="feature-item" [class.visible]="currentFeature === 2">
                        <i class="fa fa-camera"></i>
                        <span>Snap photos to capture memories</span>
                    </div>
                    <div class="feature-item" [class.visible]="currentFeature === 3">
                        <i class="fa fa-shield-alt"></i>
                        <span>Your data, securely encrypted</span>
                    </div>
                </div>

                <!-- Status -->
                <div class="setup-status">
                    <div class="status-indicator">
                        <div class="indicator-dot"></div>
                    </div>
                    <span class="status-label">{{ autoSetupMessage }}</span>
                </div>

                <!-- Elegant Circular Progress -->
                <div class="elegant-progress">
                    <svg class="progress-ring" viewBox="0 0 100 100">
                        <circle class="ring-bg" cx="50" cy="50" r="45" />
                        <circle class="ring-fill" cx="50" cy="50" r="45"
                            [style.stroke-dashoffset]="283 - (283 * setupProgress / 100)" />
                    </svg>
                    <span class="progress-text">{{ setupProgress }}%</span>
                </div>

            </div>

            <!-- Bottom Tagline -->
            <div class="bottom-tagline">
                <span>Remember everything</span>
                <span class="separator">•</span>
                <span>Recall anything</span>
            </div>
        </div>
    </div>

    <app-site-nav [showSections]="true"></app-site-nav>

    <!-- Animated Background -->
    <div class="bg-gradient"></div>
    <div class="bg-glow bg-glow-1"></div>
    <div class="bg-glow bg-glow-2"></div>
    <div class="bg-glow bg-glow-3"></div>

    <!-- Main Login View -->
    <div class="main-content" *ngIf="!otpNav">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

            <!-- Hero Section -->
            <section class="hero-section" id="login">
                <div class="hero-left">
                    <div class="brand">
                        <svg class="brand-logo" width="52" height="52" viewBox="0 0 80 80" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect width="80" height="80" rx="18" fill="#f97316" />
                            <path d="M25 18V62H55" stroke="white" stroke-width="6" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="25" cy="18" r="5" fill="white" />
                            <circle cx="55" cy="62" r="5" fill="white" />
                            <circle cx="40" cy="62" r="3" fill="white" opacity="0.6" />
                            <circle cx="25" cy="40" r="3" fill="white" opacity="0.6" />
                        </svg>
                    </div>

                    <button type="button" class="launch-badge" (click)="goToChatGptSetup()"
                        aria-label="LIAM is live in the ChatGPT app directory - set it up">
                        <span class="launch-badge-pill">New</span>
                        LIAM is live in the ChatGPT app directory
                        <svg class="launch-badge-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </button>

                    <h1 class="hero-title">
                        Remember everything.<br>
                        <span style="color:#f97316">Recall anything.</span>
                    </h1>

                    <p class="hero-subtitle">
                        Your Longitudinal Intelligent Agentic Memory. Capture memories as text or images —
                        snap a receipt, menu, or meal and let AI organize it for you.
                        Access your memories through ChatGPT, Claude AI, or Perplexity.
                    </p>

                    <div class="scroll-indicator">
                        <span>Scroll to explore features</span>
                        <div class="scroll-arrow">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 5v14M5 12l7 7 7-7" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="hero-right">
                    <div class="login-card">
                        <div class="card-header">
                            <h2>Get Started</h2>
                            <p>Start your free trial today</p>
                        </div>

                        <div class="input-group">
                            <label for="email">Email address</label>
                            <div class="input-wrapper">
                                <svg class="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2">
                                    <path
                                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>
                                <input type="email" id="email" placeholder="you@example.com" [(ngModel)]="emailId"
                                    formControlName="email" autocomplete="email">
                            </div>
                            <div *ngIf="email.invalid && email.touched" class="error-text">
                                <span *ngIf="email.errors?.['required']">Email is required</span>
                                <span *ngIf="email.errors?.['email']">Please enter a valid email</span>
                            </div>
                        </div>

                        <button class="btn-primary" type="submit" [disabled]="loginForm.invalid">
                            <span>Continue with Email</span>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M5 12h14M12 5l7 7-7 7" />
                            </svg>
                        </button>

                        <div class="divider">
                            <span>or continue with</span>
                        </div>

                        <div class="social-buttons">
                            <div id="google-signin-button" class="google-btn-wrapper"></div>
                        </div>

                        <div class="schedule-link">
                            <span>Have questions?</span>
                            <a href="https://cal.com/ashok-np-blhlrq/15min" target="_blank" class="schedule-btn">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                                Schedule a Call
                            </a>
                        </div>

                        <p class="terms-text">
                            By continuing, you agree to our
                            <a [href]="links.terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> and
                            <a [href]="links.privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                        </p>
                    </div>
                </div>
            </section>

            <!-- Demo Showcase Section -->
            <section class="demo-section" id="demo">
                <div class="section-header">
                    <span class="section-label">See It In Action</span>
                    <h2 class="section-title">One memory. <span style="color:#f97316">Access anywhere.</span></h2>
                    <p class="section-subtitle">Store your memories once. Access them through ChatGPT, Claude AI or
                        Perplexity — your choice.</p>
                </div>

                <!-- Demo Tabs -->
                <div class="demo-tabs">
                    <button class="demo-tab active" (click)="switchDemoTab('claude')"
                        [class.active]="activeDemoTab === 'claude'">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="9" width="7" height="6" rx="1" />
                            <rect x="14" y="9" width="7" height="6" rx="1" />
                            <line x1="10" y1="12" x2="14" y2="12" />
                        </svg>
                        Claude AI
                    </button>
                    <button class="demo-tab" (click)="switchDemoTab('perplexity')"
                        [class.active]="activeDemoTab === 'perplexity'">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="9" />
                            <circle cx="12" cy="12" r="4" />
                        </svg>
                        Perplexity
                    </button>
                    <button class="demo-tab" (click)="switchDemoTab('askbuddy')"
                        [class.active]="activeDemoTab === 'askbuddy'">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="3" width="18" height="18" rx="2" />
                            <circle cx="12" cy="10" r="3" />
                            <path d="M7 18c0-2.5 2.2-4 5-4s5 1.5 5 4" />
                        </svg>
                        AskBuddy
                    </button>
                </div>

                <!-- Claude AI Demo -->
                <div class="demo-carousel-container" [class.hidden]="activeDemoTab !== 'claude'">
                    <div class="demo-carousel">
                        <!-- Demo 1: Ask about bills -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-1.png" alt="Asking Claude about hydro payment"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">1</span>
                                <h4>Ask naturally</h4>
                                <p>"Did I pay my hydro this month?"</p>
                            </div>
                        </div>

                        <!-- Demo 2: Diet tracking - record meal -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-8.png" alt="Track daily diet with photos"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">2</span>
                                <h4>Track your daily diet</h4>
                                <p>Snap a meal photo, Claude logs calories automatically</p>
                            </div>
                        </div>

                        <!-- Demo 3: Diet summary with calories -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-9.png" alt="Daily calorie summary" loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">3</span>
                                <h4>Get daily calorie totals</h4>
                                <p>Claude remembers all meals and calculates your intake</p>
                            </div>
                        </div>

                        <!-- Demo 4: Memory + Email search -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-2.png" alt="Claude searching memory and email"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">4</span>
                                <h4>AI searches your memory + email</h4>
                                <p>Finds payment history & new bills</p>
                            </div>
                        </div>

                        <!-- Demo 5: Follow-up question -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-3.png" alt="Asking about local saffron"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">5</span>
                                <h4>Ask anything personal</h4>
                                <p>"Where is the local saffron place?"</p>
                            </div>
                        </div>

                        <!-- Demo 6: Local marketplace items -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-4.png" alt="Claude listing local marketplace items"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">6</span>
                                <h4>Get personalized answers</h4>
                                <p>Your favorite stores & items</p>
                            </div>
                        </div>

                        <!-- Demo 7: Purchase history & budget -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-5.png" alt="Purchase history and budget info"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">7</span>
                                <h4>Rich context from your life</h4>
                                <p>Purchase history, budgets & more</p>
                            </div>
                        </div>

                        <!-- Demo 8: Image capture -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-6.png" alt="Uploading image to save" loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">8</span>
                                <h4>Snap & save anything</h4>
                                <p>Upload images with a quick note</p>
                            </div>
                        </div>

                        <!-- Demo 9: AI extracts details -->
                        <div class="demo-item">
                            <div class="phone-mockup">
                                <div class="phone-notch"></div>
                                <img src="assets/images/demo/demo-7.png" alt="AI extracts and saves details"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <span class="demo-step">9</span>
                                <h4>AI extracts all details</h4>
                                <p>Price, location, condition — auto-tagged</p>
                            </div>
                        </div>
                    </div>

                    <div class="demo-scroll-hint">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                        <span>Scroll to see more</span>
                    </div>
                </div>

                <!-- Perplexity Demo -->
                <div class="demo-carousel-container perplexity-demos" [class.hidden]="activeDemoTab !== 'perplexity'">
                    <div class="demo-grid-desktop">
                        <!-- Perplexity Demo 1: Coffee machine analysis -->
                        <div class="demo-item-desktop">
                            <div class="browser-mockup">
                                <div class="browser-header">
                                    <div class="browser-dots">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div class="browser-url">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <circle cx="12" cy="12" r="9" />
                                            <circle cx="12" cy="12" r="4" />
                                        </svg>
                                        perplexity.ai
                                    </div>
                                </div>
                                <img src="assets/images/demo/perplexity-1.png"
                                    alt="Perplexity analyzing coffee machine deal" loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <h4>Smart purchase decisions</h4>
                                <p>"Check my memory for coffee machine deal — is it worth it?"</p>
                                <span class="demo-highlight">Perplexity searches web + your memories for price
                                    comparison</span>
                            </div>
                        </div>

                        <!-- Perplexity Demo 2: Grocery expense tracking -->
                        <div class="demo-item-desktop">
                            <div class="browser-mockup">
                                <div class="browser-header">
                                    <div class="browser-dots">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div class="browser-url">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <circle cx="12" cy="12" r="9" />
                                            <circle cx="12" cy="12" r="4" />
                                        </svg>
                                        perplexity.ai
                                    </div>
                                </div>
                                <img src="assets/images/demo/perplexity-2.png"
                                    alt="Perplexity tracking grocery expenses" loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <h4>Track your spending</h4>
                                <p>"What is my grocery expense this month?"</p>
                                <span class="demo-highlight">Access your stored receipts & expense tags instantly</span>
                            </div>
                        </div>

                        <!-- Perplexity Demo 3: Restaurant recommendations by preferences -->
                        <div class="demo-item-desktop">
                            <div class="browser-mockup">
                                <div class="browser-header">
                                    <div class="browser-dots">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div class="browser-url">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <circle cx="12" cy="12" r="9" />
                                            <circle cx="12" cy="12" r="4" />
                                        </svg>
                                        perplexity.ai
                                    </div>
                                </div>
                                <img src="assets/images/demo/perplexity-3.png"
                                    alt="Perplexity recommending restaurants based on diet preferences" loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <h4>Personalized recommendations</h4>
                                <p>"Check my diet and preferences — find good restaurants nearby"</p>
                                <span class="demo-highlight">AI knows your food preferences & finds matching local
                                    spots</span>
                            </div>
                        </div>
                    </div>

                    <div class="perplexity-note">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4M12 8h.01" />
                        </svg>
                        <span>Same memories, different AI — Perplexity adds web search to your personal context</span>
                    </div>
                </div>

                <!-- AskBuddy Demo -->
                <div class="demo-carousel-container askbuddy-demos" [class.hidden]="activeDemoTab !== 'askbuddy'">
                    <div class="demo-grid-desktop">
                        <!-- AskBuddy Demo 1: Chat interface -->
                        <div class="demo-item-desktop">
                            <div class="browser-mockup">
                                <div class="browser-header">
                                    <div class="browser-dots">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div class="browser-url">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <rect x="3" y="3" width="18" height="18" rx="2" />
                                            <circle cx="12" cy="10" r="3" />
                                        </svg>
                                        liam.com
                                    </div>
                                </div>
                                <img src="assets/images/demo/askbuddy-1.png" alt="LIAM AskBuddy chat interface"
                                    loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <h4>Built-in AI chat</h4>
                                <p>"Check local buy and let me about the coffee machine"</p>
                                <span class="demo-highlight">Search and chat with your memories directly in
                                    LIAM</span>
                            </div>
                        </div>

                        <!-- AskBuddy Demo 2: AI response -->
                        <div class="demo-item-desktop">
                            <div class="browser-mockup">
                                <div class="browser-header">
                                    <div class="browser-dots">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div class="browser-url">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <rect x="3" y="3" width="18" height="18" rx="2" />
                                            <circle cx="12" cy="10" r="3" />
                                        </svg>
                                        liam.com
                                    </div>
                                </div>
                                <img src="assets/images/demo/askbuddy-2.png" alt="AskBuddy AI response" loading="lazy">
                            </div>
                            <div class="demo-caption">
                                <h4>Instant AI summaries</h4>
                                <p>Get organized answers from your stored memories</p>
                                <span class="demo-highlight">No external AI needed — works right in your browser</span>
                            </div>
                        </div>
                    </div>

                    <div class="askbuddy-note">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        </svg>
                        <span>Your fallback option — access memories anytime at liam.com, no AI connectors
                            required</span>
                    </div>
                </div>
            </section>

            <!-- Architecture Diagram Section -->
            <section class="architecture-section" id="architecture">
                <div class="section-header">
                    <span class="section-label">Architecture</span>
                    <h2 class="section-title">The <span style="color:#f97316">LIAM</span> Architecture</h2>
                    <p class="section-subtitle">One memory, accessible everywhere</p>
                </div>

                <div class="arch-diagram">
                    <!-- Layer 1: AI Apps -->
                    <div class="arch-layer">
                        <span class="arch-layer-label">AI Applications</span>
                        <div class="ai-apps-groups">
                            <div class="app-group assistants">
                                <span class="app-group-label">Chat assistants</span>
                                <div class="app-group-cards">
                                    <div class="ai-app-card">
                                        <svg viewBox="0 0 40 40" fill="none" stroke="#d97706" stroke-width="2">
                                            <rect x="4" y="4" width="32" height="32" rx="8" />
                                            <circle cx="14" cy="16" r="2.5" fill="#d97706" />
                                            <circle cx="26" cy="16" r="2.5" fill="#d97706" />
                                            <path d="M14 26c3 3 9 3 12 0" />
                                        </svg>
                                        <h4>Claude AI</h4>
                                        <p>Desktop &amp; Mobile</p>
                                        <span class="app-conn mcp">MCP</span>
                                    </div>
                                    <div class="ai-app-card">
                                        <svg viewBox="0 0 40 40" fill="none" stroke="#10a37f" stroke-width="2">
                                            <path
                                                d="M8 10h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H16l-6 6v-6H8a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2z" />
                                            <circle cx="15" cy="19" r="1.6" fill="#10a37f" />
                                            <circle cx="20" cy="19" r="1.6" fill="#10a37f" />
                                            <circle cx="25" cy="19" r="1.6" fill="#10a37f" />
                                        </svg>
                                        <h4>ChatGPT</h4>
                                        <p>Web &amp; Desktop</p>
                                        <span class="app-conn mcp">MCP</span>
                                    </div>
                                    <div class="ai-app-card">
                                        <svg viewBox="0 0 40 40" fill="none" stroke="#6b7280" stroke-width="2">
                                            <rect x="5" y="8" width="30" height="24" rx="3" />
                                            <path d="M12 18l4 3-4 3" stroke-linecap="round" stroke-linejoin="round" />
                                            <line x1="20" y1="26" x2="27" y2="26" stroke-linecap="round" />
                                        </svg>
                                        <h4>OpenClaw</h4>
                                        <p>CLI &amp; Self-hosted</p>
                                        <span class="app-conn mcp">MCP</span>
                                    </div>
                                    <div class="ai-app-card">
                                        <svg viewBox="0 0 40 40" fill="none" stroke="#22d3ee" stroke-width="2">
                                            <circle cx="20" cy="20" r="14" />
                                            <circle cx="20" cy="20" r="6" />
                                        </svg>
                                        <h4>Perplexity</h4>
                                        <p>Search + Memory</p>
                                        <span class="app-conn mcp">MCP</span>
                                    </div>
                                </div>
                            </div>

                            <div class="app-group-divider"></div>

                            <div class="app-group custom">
                                <span class="app-group-label">Build your own</span>
                                <div class="app-group-cards">
                                    <div class="ai-app-card">
                                        <svg viewBox="0 0 40 40" fill="none" stroke="#a855f7" stroke-width="2">
                                            <rect x="4" y="4" width="32" height="32" rx="6" />
                                            <circle cx="20" cy="15" r="5" />
                                            <path d="M10 34c0-5 4.5-8 10-8s10 3 10 8" />
                                        </svg>
                                        <h4>AskBuddy</h4>
                                        <p>Web Interface</p>
                                        <span class="app-conn api">API</span>
                                    </div>
                                    <div class="ai-app-card">
                                        <svg viewBox="0 0 40 40" fill="none" stroke="#10b981" stroke-width="2">
                                            <path d="M20 6v8M26 10l-6 6-6-6" />
                                            <rect x="6" y="18" width="28" height="16" rx="4" />
                                            <circle cx="14" cy="26" r="2" fill="#10b981" />
                                            <circle cx="20" cy="26" r="2" fill="#10b981" />
                                            <circle cx="26" cy="26" r="2" fill="#10b981" />
                                        </svg>
                                        <h4>Your App</h4>
                                        <p>REST API</p>
                                        <span class="app-conn api">API</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Single clean connector into the hub -->
                    <div class="arch-flow">
                        <span class="arch-flow-label">Every app connects to LIAM via <b>MCP</b> or <b>REST API</b></span>
                        <div class="arch-flow-arrow"></div>
                    </div>

                    <!-- Layer 2: LIAM Core -->
                    <div class="arch-layer arch-layer-core">
                        <span class="arch-layer-label">Memory Hub</span>
                        <div class="liam-core">
                            <div class="liam-logo-section">
                                <svg class="liam-arch-logo" viewBox="0 0 80 80" fill="none">
                                    <rect width="80" height="80" rx="18" fill="#f97316" />
                                    <path d="M25 18V62H55" stroke="white" stroke-width="6" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <circle cx="25" cy="18" r="5" fill="white" />
                                    <circle cx="55" cy="62" r="5" fill="white" />
                                    <circle cx="40" cy="62" r="3" fill="white" opacity="0.6" />
                                    <circle cx="25" cy="40" r="3" fill="white" opacity="0.6" />
                                </svg>
                                <div>
                                    <h3>LIAM</h3>
                                    <p>Longitudinal Intelligent Agentic Memory</p>
                                </div>
                            </div>
                            <div class="liam-features-row">
                                <div class="xd-feature-badge">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="2">
                                        <rect x="3" y="11" width="18" height="11" rx="2" />
                                        <path d="M7 11V7a5 5 0 0110 0v4" />
                                    </svg>
                                    <span>Encrypted</span>
                                </div>
                                <div class="xd-feature-badge">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="2">
                                        <circle cx="11" cy="11" r="8" />
                                        <path d="M21 21l-4.35-4.35" />
                                    </svg>
                                    <span>Semantic Search</span>
                                </div>
                                <div class="xd-feature-badge">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="2">
                                        <path
                                            d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                                    </svg>
                                    <span>Always Synced</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Connection Arrows -->
                    <div class="arch-connections">
                        <div class="arch-conn">
                            <div class="arch-arrow"></div><span>Store</span>
                        </div>
                        <div class="arch-conn">
                            <div class="arch-arrow"></div><span>Index</span>
                        </div>
                        <div class="arch-conn">
                            <div class="arch-arrow"></div><span>Tag</span>
                        </div>
                        <div class="arch-conn">
                            <div class="arch-arrow"></div><span>Search</span>
                        </div>
                    </div>

                    <!-- Layer 3: Memory Types -->
                    <div class="arch-layer">
                        <span class="arch-layer-label">Your Memories</span>
                        <div class="memory-types-grid">
                            <div class="memory-type-card">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#f97316" stroke-width="2">
                                    <path d="M12 20h9M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
                                </svg>
                                <span>Notes</span>
                            </div>
                            <div class="memory-type-card">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#22d3ee" stroke-width="2">
                                    <rect x="3" y="3" width="18" height="18" rx="2" />
                                    <circle cx="8.5" cy="8.5" r="1.5" />
                                    <path d="M21 15l-5-5L5 21" />
                                </svg>
                                <span>Photos</span>
                            </div>
                            <div class="memory-type-card">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#a855f7" stroke-width="2">
                                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                                    <path d="M14 2v6h6" />
                                </svg>
                                <span>Receipts</span>
                            </div>
                            <div class="memory-type-card">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 6v6l4 2" />
                                </svg>
                                <span>Reminders</span>
                            </div>
                            <div class="memory-type-card">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#eab308" stroke-width="2">
                                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
                                </svg>
                                <span>Ideas</span>
                            </div>
                            <div class="memory-type-card">
                                <svg viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2">
                                    <path
                                        d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
                                </svg>
                                <span>Diet</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Features Grid Section -->
            <section class="features-section" id="features">
                <div class="section-header">
                    <span class="section-label">How It Works</span>
                    <h2 class="section-title">Capture memories. <span style="color:#f97316">Access them anywhere.</span>
                    </h2>
                </div>

                <div class="features-grid">
                    <div class="feature-card" (click)="scrollToFeature('memories')">
                        <div class="feature-icon-wrap">
                            <svg class="feature-icon" viewBox="0 0 32 32" fill="none">
                                <rect x="4" y="4" width="24" height="24" rx="3" stroke="#f97316" stroke-width="2" />
                                <line x1="9" y1="10" x2="23" y2="10" stroke="#f97316" stroke-width="2"
                                    stroke-linecap="round" />
                                <line x1="9" y1="16" x2="20" y2="16" stroke="#f97316" stroke-width="2"
                                    stroke-linecap="round" />
                                <line x1="9" y1="22" x2="17" y2="22" stroke="#f97316" stroke-width="2"
                                    stroke-linecap="round" />
                            </svg>
                        </div>
                        <h3>Text Memories</h3>
                        <p>Type or paste anything — notes, links, thoughts, ideas. Your knowledge base that grows with
                            you.</p>
                    </div>

                    <div class="feature-card featured" (click)="scrollToFeature('images')">
                        <div class="badge-hot">NEW</div>
                        <div class="feature-icon-wrap">
                            <svg class="feature-icon" viewBox="0 0 32 32" fill="none">
                                <rect x="4" y="6" width="24" height="20" rx="3" stroke="#f97316" stroke-width="2" />
                                <circle cx="11" cy="13" r="3" stroke="#f97316" stroke-width="2" />
                                <path d="M4 22l6-5 4 3 8-7 6 5" stroke="#f97316" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <h3>Image Capture</h3>
                        <p>Snap receipts, menus, meals, screenshots — AI analyzes and organizes them automatically.</p>
                    </div>

                    <div class="feature-card featured" (click)="scrollToSection('tutorial')">
                        <div class="badge-hot">HOT</div>
                        <div class="feature-icon-wrap">
                            <svg class="feature-icon" viewBox="0 0 32 32" fill="none">
                                <rect x="4" y="12" width="10" height="8" rx="2" stroke="#f97316" stroke-width="2" />
                                <rect x="18" y="12" width="10" height="8" rx="2" stroke="#f97316" stroke-width="2" />
                                <line x1="14" y1="16" x2="18" y2="16" stroke="#f97316" stroke-width="2" />
                                <circle cx="9" cy="6" r="2" fill="#f97316" opacity="0.5" />
                                <circle cx="23" cy="6" r="2" fill="#f97316" opacity="0.5" />
                                <line x1="9" y1="8" x2="9" y2="12" stroke="#f97316" stroke-width="1.5" opacity="0.4" />
                                <line x1="23" y1="8" x2="23" y2="12" stroke="#f97316" stroke-width="1.5"
                                    opacity="0.4" />
                                <circle cx="9" cy="26" r="2" fill="#f97316" opacity="0.5" />
                                <circle cx="23" cy="26" r="2" fill="#f97316" opacity="0.5" />
                                <line x1="9" y1="20" x2="9" y2="24" stroke="#f97316" stroke-width="1.5" opacity="0.4" />
                                <line x1="23" y1="20" x2="23" y2="24" stroke="#f97316" stroke-width="1.5"
                                    opacity="0.4" />
                            </svg>
                        </div>
                        <h3>AI Assistant Connectors</h3>
                        <p>Connect LIAM to Claude, ChatGPT, or OpenClaw — your memories become context for smarter,
                            personalized conversations.</p>
                    </div>

                    <div class="feature-card featured" (click)="scrollToSection('demo')">
                        <div class="badge-hot">HOT</div>
                        <div class="feature-icon-wrap">
                            <svg class="feature-icon" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="11" stroke="#f97316" stroke-width="2" />
                                <circle cx="16" cy="16" r="5" stroke="#f97316" stroke-width="2" />
                                <line x1="16" y1="5" x2="16" y2="11" stroke="#f97316" stroke-width="1.5"
                                    opacity="0.4" />
                                <line x1="25" y1="20" x2="20" y2="18" stroke="#f97316" stroke-width="1.5"
                                    opacity="0.4" />
                                <line x1="7" y1="20" x2="12" y2="18" stroke="#f97316" stroke-width="1.5"
                                    opacity="0.4" />
                                <circle cx="16" cy="4" r="1.5" fill="#f97316" opacity="0.5" />
                                <circle cx="26" cy="22" r="1.5" fill="#f97316" opacity="0.5" />
                                <circle cx="6" cy="22" r="1.5" fill="#f97316" opacity="0.5" />
                            </svg>
                        </div>
                        <h3>Perplexity Connector</h3>
                        <p>Connect to Perplexity Desktop. Search the web with your personal context built-in.</p>
                    </div>

                    <div class="feature-card" (click)="scrollToFeature('search')">
                        <div class="feature-icon-wrap">
                            <svg class="feature-icon" viewBox="0 0 32 32" fill="none">
                                <circle cx="14" cy="14" r="8" stroke="#f97316" stroke-width="2" />
                                <line x1="20" y1="20" x2="27" y2="27" stroke="#f97316" stroke-width="2.5"
                                    stroke-linecap="round" />
                                <circle cx="14" cy="14" r="3" stroke="#f97316" stroke-width="1.5" opacity="0.4" />
                                <circle cx="14" cy="8" r="1" fill="#f97316" opacity="0.5" />
                            </svg>
                        </div>
                        <h3>Instant Search</h3>
                        <p>Find anything in milliseconds with semantic search across all your memories and images.</p>
                    </div>

                    <div class="feature-card" (click)="scrollToFeature('reminders')">
                        <div class="feature-icon-wrap">
                            <svg class="feature-icon" viewBox="0 0 32 32" fill="none">
                                <circle cx="16" cy="16" r="11" stroke="#f97316" stroke-width="2" />
                                <line x1="16" y1="16" x2="16" y2="9" stroke="#f97316" stroke-width="2"
                                    stroke-linecap="round" />
                                <line x1="16" y1="16" x2="21" y2="16" stroke="#f97316" stroke-width="2"
                                    stroke-linecap="round" />
                                <circle cx="16" cy="16" r="2" fill="#f97316" />
                                <circle cx="16" cy="3" r="1.5" fill="#f97316" opacity="0.5" />
                                <line x1="16" y1="3" x2="16" y2="5" stroke="#f97316" stroke-width="1" opacity="0.4" />
                            </svg>
                        </div>
                        <h3>Smart Reminders</h3>
                        <p>Set follow-ups and get notified at the right time. Never miss important tasks.</p>
                    </div>
                </div>
            </section>

            <!-- Feature Details Section -->
            <section class="details-section" id="connectors">
                <!-- Text Memories -->
                <div class="detail-card" id="feature-memories">
                    <div class="detail-content">
                        <svg class="detail-icon" viewBox="0 0 32 32" fill="none">
                            <rect x="4" y="4" width="24" height="24" rx="3" stroke="#f97316" stroke-width="2" />
                            <line x1="9" y1="10" x2="23" y2="10" stroke="#f97316" stroke-width="2"
                                stroke-linecap="round" />
                            <line x1="9" y1="16" x2="20" y2="16" stroke="#f97316" stroke-width="2"
                                stroke-linecap="round" />
                            <line x1="9" y1="22" x2="17" y2="22" stroke="#f97316" stroke-width="2"
                                stroke-linecap="round" />
                        </svg>
                        <h3>Text Memories</h3>
                        <p>Type or paste anything you want to remember — quick notes, links, thoughts, ideas, meeting
                            notes, or important information. Your personal knowledge base grows with every entry.</p>
                        <div class="detail-tags">
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <path d="M3 3h10v10H3z" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="5" y1="6" x2="11" y2="6" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="5" y1="9" x2="9" y2="9" stroke="#f97316" stroke-width="1.5" />
                                </svg> Quick Notes</span>
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <circle cx="6" cy="8" r="3" stroke="#f97316" stroke-width="1.5" />
                                    <circle cx="10" cy="8" r="3" stroke="#f97316" stroke-width="1.5" />
                                </svg> Links</span>
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <path d="M8 2L8 6M8 6L10 8M8 6L6 8" stroke="#f97316" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <circle cx="8" cy="11" r="3" stroke="#f97316" stroke-width="1.5" />
                                </svg> Ideas</span>
                        </div>
                    </div>
                </div>

                <!-- Image Capture -->
                <div class="detail-card featured" id="feature-images">
                    <div class="detail-content">
                        <svg class="detail-icon" viewBox="0 0 32 32" fill="none">
                            <rect x="4" y="6" width="24" height="20" rx="3" stroke="#f97316" stroke-width="2" />
                            <circle cx="11" cy="13" r="3" stroke="#f97316" stroke-width="2" />
                            <path d="M4 22l6-5 4 3 8-7 6 5" stroke="#f97316" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <h3>Image Capture <span class="badge-inline">NEW</span></h3>
                        <p>Take a photo of anything and our AI will analyze, understand, and organize it for you.
                            Perfect for capturing information on the go.</p>
                        <div class="mcp-benefits">
                            <div class="benefit"><svg viewBox="0 0 20 20" fill="none">
                                    <rect x="3" y="2" width="14" height="16" rx="1" stroke="#f97316"
                                        stroke-width="1.5" />
                                    <line x1="6" y1="6" x2="14" y2="6" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="6" y1="9" x2="14" y2="9" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="6" y1="12" x2="10" y2="12" stroke="#f97316" stroke-width="1.5" />
                                </svg><span>Receipts & invoices</span></div>
                            <div class="benefit"><svg viewBox="0 0 20 20" fill="none">
                                    <rect x="3" y="3" width="14" height="14" rx="2" stroke="#f97316"
                                        stroke-width="1.5" />
                                    <line x1="6" y1="7" x2="14" y2="7" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="6" y1="10" x2="14" y2="10" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="6" y1="13" x2="11" y2="13" stroke="#f97316" stroke-width="1.5" />
                                </svg><span>Restaurant menus</span></div>
                            <div class="benefit"><svg viewBox="0 0 20 20" fill="none">
                                    <circle cx="10" cy="8" r="4" stroke="#f97316" stroke-width="1.5" />
                                    <path d="M6 16c0-2 2-4 4-4s4 2 4 4" stroke="#f97316" stroke-width="1.5" />
                                </svg><span>Food & meals you eat</span></div>
                            <div class="benefit"><svg viewBox="0 0 20 20" fill="none">
                                    <rect x="3" y="3" width="14" height="10" rx="1" stroke="#f97316"
                                        stroke-width="1.5" />
                                    <line x1="3" y1="16" x2="17" y2="16" stroke="#f97316" stroke-width="1.5" />
                                </svg><span>Screenshots & notes</span></div>
                        </div>
                        <p class="highlight-text">AI automatically extracts text, adds tags, and makes everything
                            searchable.</p>
                    </div>
                </div>

                <!-- Claude & Perplexity connector benefits moved into the setup wizard app picker -->

                <!-- Instant Search -->
                <div class="detail-card" id="feature-search">
                    <div class="detail-content">
                        <svg class="detail-icon" viewBox="0 0 32 32" fill="none">
                            <circle cx="14" cy="14" r="8" stroke="#f97316" stroke-width="2" />
                            <line x1="20" y1="20" x2="27" y2="27" stroke="#f97316" stroke-width="2.5"
                                stroke-linecap="round" />
                            <circle cx="14" cy="14" r="3" stroke="#f97316" stroke-width="1.5" opacity="0.4" />
                        </svg>
                        <h3>Instant Search</h3>
                        <p>Find anything you've saved in milliseconds with smart semantic search powered by AI. Search
                            across text and images.</p>
                        <div class="detail-tags">
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <path d="M4 4l4 2v6l-4-2V4zM12 4l-4 2v6l4-2V4z" stroke="#f97316"
                                        stroke-width="1.5" />
                                </svg> By Tags</span>
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <path d="M3 3h10v10H3z" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="5" y1="6" x2="11" y2="6" stroke="#f97316" stroke-width="1.5" />
                                    <line x1="5" y1="9" x2="9" y2="9" stroke="#f97316" stroke-width="1.5" />
                                </svg> By Content</span>
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <rect x="3" y="3" width="10" height="10" rx="1" stroke="#f97316"
                                        stroke-width="1.5" />
                                    <circle cx="6" cy="7" r="1.5" stroke="#f97316" stroke-width="1" />
                                </svg> By Images</span>
                        </div>
                    </div>
                </div>

                <!-- Smart Reminders -->
                <div class="detail-card" id="feature-reminders">
                    <div class="detail-content">
                        <svg class="detail-icon" viewBox="0 0 32 32" fill="none">
                            <circle cx="16" cy="16" r="11" stroke="#f97316" stroke-width="2" />
                            <line x1="16" y1="16" x2="16" y2="9" stroke="#f97316" stroke-width="2"
                                stroke-linecap="round" />
                            <line x1="16" y1="16" x2="21" y2="16" stroke="#f97316" stroke-width="2"
                                stroke-linecap="round" />
                            <circle cx="16" cy="16" r="2" fill="#f97316" />
                        </svg>
                        <h3>Smart Reminders</h3>
                        <p>Set follow-ups on any memory. Get notified when you need to take action — never miss
                            important tasks or deadlines.</p>
                        <div class="detail-tags">
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <rect x="3" y="3" width="10" height="10" rx="1" stroke="#f97316"
                                        stroke-width="1.5" />
                                    <line x1="3" y1="6" x2="13" y2="6" stroke="#f97316" stroke-width="1.5" />
                                </svg> Follow-ups</span>
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="5" stroke="#f97316" stroke-width="1.5" />
                                    <circle cx="8" cy="8" r="1.5" fill="#f97316" />
                                </svg> Deadlines</span>
                            <span class="tag"><svg viewBox="0 0 16 16" fill="none">
                                    <path d="M8 3v2M8 11v2M3 8h2M11 8h2" stroke="#f97316" stroke-width="1.5"
                                        stroke-linecap="round" />
                                    <circle cx="8" cy="8" r="3" stroke="#f97316" stroke-width="1.5" />
                                </svg> Check-ins</span>
                        </div>
                    </div>
                </div>
            </section>

            <!-- API Tools Section -->
            <!-- API section hidden — the dedicated Developers page covers the API. Remove *ngIf="false" to restore. -->
            <section class="api-section" id="api" *ngIf="false">
                <div class="api-toggle" (click)="toggleApiTools()">
                    <div class="api-toggle-left">
                        <svg class="api-icon" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"
                                stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <h3>API Documentation</h3>
                    </div>
                    <div class="toggle-arrow" [class.open]="showApiTools">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M6 9l6 6 6-6" />
                        </svg>
                    </div>
                </div>

                <div class="api-content" *ngIf="showApiTools">
                    <div class="api-intro">
                        <p>LIAM provides a comprehensive REST API for managing memories programmatically. All
                            endpoints require authentication via API key and signature.</p>
                        <div class="api-auth-note">
                            <svg viewBox="0 0 20 20" fill="none">
                                <rect x="5" y="9" width="10" height="8" rx="1" stroke="#f97316" stroke-width="1.5" />
                                <path d="M7 9V6a3 3 0 016 0v3" stroke="#f97316" stroke-width="1.5" />
                            </svg>
                            <span><strong>Authentication:</strong> Include <code>apiKey</code> and
                                <code>signature</code> headers with each request</span>
                        </div>
                    </div>

                    <!-- User Management APIs -->
                    <div class="api-category">
                        <h4><svg viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="7" r="4" stroke="#f97316" stroke-width="1.5" />
                                <path d="M4 18c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="#f97316" stroke-width="1.5" />
                            </svg>User Management</h4>
                        <div class="api-grid">
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/auth/register</div>
                                    <div class="api-desc">Register a new connector with institution details</div>
                                    <code>{{ '{' }} "name": "string", "institutionId": "string", "institutionName": "string" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/auth/activate</div>
                                    <div class="api-desc">Activate a registered connector</div>
                                    <code>{{ '{' }} "name": "string" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/profile/create</div>
                                    <div class="api-desc">Create a user profile to store memories</div>
                                    <code>{{ '{' }} "email": "string", "name": "string" {{ '}' }}</code>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Memory APIs -->
                    <div class="api-category">
                        <h4><svg viewBox="0 0 20 20" fill="none">
                                <rect x="4" y="3" width="12" height="14" rx="2" stroke="#f97316" stroke-width="1.5" />
                                <line x1="7" y1="7" x2="13" y2="7" stroke="#f97316" stroke-width="1.5" />
                                <line x1="7" y1="10" x2="11" y2="10" stroke="#f97316" stroke-width="1.5" />
                            </svg>Memory Operations</h4>
                        <div class="api-grid">
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/create</div>
                                    <div class="api-desc">Create a new text memory with optional tag</div>
                                    <code>{{ '{' }} "userKey": "string", "content": "string", "tag": "string?", "sessionId": "string?" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/create-with-image</div>
                                    <div class="api-desc">Create a memory with an attached image</div>
                                    <code>{{ '{' }} "userKey": "string", "content": "string", "image": "base64", "tag": "string?" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/list</div>
                                    <div class="api-desc">Search and retrieve memories with filters</div>
                                    <code>{{ '{' }} "userKey": "string", "query": "string?", "tokens": ["string"]?, "require_llm_summary": false {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/chat</div>
                                    <div class="api-desc">Chat with your memories using AI (AskBuddy)</div>
                                    <code>{{ '{' }} "userKey": "string", "statement": "string", "existing_tags": ["string"]? {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/summarize</div>
                                    <div class="api-desc">Get an AI summary of specific memories</div>
                                    <code>{{ '{' }} "userKey": "string", "transactionNumbers": ["string"] {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/forget</div>
                                    <div class="api-desc">Delete a memory by transaction number</div>
                                    <code>{{ '{' }} "userKey": "string", "transactionNumber": "string" {{ '}' }}</code>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tag APIs -->
                    <div class="api-category">
                        <h4><svg viewBox="0 0 20 20" fill="none">
                                <path d="M4 4l4 2v6l-4-2V4zM12 4l4 2v6l-4-2V4z" stroke="#f97316" stroke-width="1.5" />
                            </svg>Tag Management</h4>
                        <div class="api-grid">
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/list-tag</div>
                                    <div class="api-desc">Get all tags for a user</div>
                                    <code>{{ '{' }} "userKey": "string" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/add-tag</div>
                                    <div class="api-desc">Add a new tag to organize memories</div>
                                    <code>{{ '{' }} "userKey": "string", "sessionId": "string", "tag": "string" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/get-by-tag</div>
                                    <div class="api-desc">Retrieve all memories with a specific tag</div>
                                    <code>{{ '{' }} "userKey": "string", "tag": "string" {{ '}' }}</code>
                                </div>
                            </div>
                            <div class="api-card">
                                <div class="api-method post">POST</div>
                                <div class="api-details">
                                    <div class="api-name">/api/memory/change-tag</div>
                                    <div class="api-desc">Update the tag on an existing memory</div>
                                    <code>{{ '{' }} "userKey": "string", "transactionNumber": "string", "newTag": "string" {{ '}' }}</code>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Response Format -->
                    <div class="api-response-format">
                        <h4><svg viewBox="0 0 20 20" fill="none">
                                <rect x="3" y="3" width="14" height="14" rx="2" stroke="#f97316" stroke-width="1.5" />
                                <path d="M7 7h6M7 10h4M7 13h5" stroke="#f97316" stroke-width="1.5" />
                            </svg>Response Format</h4>
                        <div class="response-example">
                            <pre><code>{{'{'}}"status": "Success",
"message": "Your memory has been recorded successfully.",
"data": {{'{'}}...{{'}'}} ,
"timestamp": "2025-03-26T07:37:25.314532+00:00",
"processId": "295492e00a1511f0a7eee880883aad51"
{{'}'}}</code></pre>
                        </div>
                    </div>

                    <div class="api-cta">
                        <a href="https://context-engine-api-850373.postman.co/workspace/5e77a115-4e64-450c-8627-641f954633bd/collection/34398137-858009dc-6ae2-4f3c-82cf-69390a816b40"
                            target="_blank" class="btn-outline">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="3" width="18" height="18" rx="2" />
                                <path d="M9 9h6M9 12h6M9 15h4" />
                            </svg>
                            View Full API in Postman
                        </a>
                    </div>
                </div>
            </section>

            <!-- Video Tutorial Section (commented out — keeping step-by-step screens only) -->
            <!--
            <section class="video-section">
                <div class="video-header">
                    <svg class="video-icon" viewBox="0 0 32 32" fill="none">
                        <rect x="4" y="6" width="24" height="20" rx="3" stroke="#f97316" stroke-width="2" />
                        <path d="M13 12l8 4-8 4V12z" fill="#f97316" />
                    </svg>
                    <div>
                        <h3>Watch: MCP Integration Tutorial</h3>
                        <p>Learn how to connect LIAM with Claude AI in under 3 minutes</p>
                    </div>
                </div>
                <div class="video-container">
                    <video controls class="tutorial-video" preload="metadata">
                        <source src="assets/videos/mcp_connector_tutorial_vertical_captioned.mp4" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </section>
            -->

            <!-- Connector Setup Guide -->
            <section class="connector-guide" id="tutorial">
                <div class="section-header">
                    <span class="section-label">Easy setup</span>
                    <h2 class="section-title">Connect LIAM in a <span style="color:#f97316">few taps</span></h2>
                    <p class="section-subtitle">We'll walk you through it — one simple step at a time.</p>
                    <div class="mcp-hint">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16"
                            height="16">
                            <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1h6c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z" />
                        </svg>
                        <span>One memory, everywhere — connect LIAM to <strong>Claude, ChatGPT and OpenClaw</strong>. Add from any app, and it's all searchable across every app.</span>
                    </div>
                </div>

                <div class="wizard">

                    <!-- Screen A: pick your app -->
                    <div class="wiz-pick" *ngIf="!wizardPlatform">
                        <h3 class="wiz-pick-title">Connect LIAM to your apps</h3>
                        <p class="wiz-pick-sub">Set up as many as you like — it's one shared memory. Start with any:</p>
                        <div class="wiz-pick-cards">
                            <button type="button" class="wiz-pick-card" (click)="startWizard('claude')">
                                <span class="wiz-pick-ico claude">✳</span>
                                <b>Claude</b>
                                <span class="wiz-pick-time">about 1 minute</span>
                                <ul class="wiz-pick-benefits">
                                    <li>Remembers your preferences</li>
                                    <li>Personalized, contextual replies</li>
                                    <li>Auto-syncs your memories</li>
                                </ul>
                            </button>
                            <button type="button" class="wiz-pick-card" (click)="startWizard('chatgpt')">
                                <span class="wiz-pick-ico gpt">◍</span>
                                <b>ChatGPT</b>
                                <span class="wiz-pick-time">about 1 minute</span>
                                <ul class="wiz-pick-benefits">
                                    <li>Answers using your memories</li>
                                    <li>Personalized, contextual replies</li>
                                    <li>Auto-syncs your memories</li>
                                </ul>
                            </button>
                            <button type="button" class="wiz-pick-card" (click)="startWizard('muse')">
                                <span class="wiz-pick-ico muse">◆</span>
                                <b>Muse</b>
                                <span class="wiz-pick-time">about 1 minute</span>
                                <ul class="wiz-pick-benefits">
                                    <li>Connects by chat — no forms</li>
                                    <li>Same memories as your other apps</li>
                                    <li>Reads and writes your memory</li>
                                </ul>
                            </button>
                            <button type="button" class="wiz-pick-card" (click)="startWizard('openclaw')">
                                <span class="wiz-pick-ico openclaw">&lt;/&gt;</span>
                                <b>OpenClaw</b>
                                <span class="wiz-pick-time">for developers</span>
                                <ul class="wiz-pick-benefits">
                                    <li>Full command-line control</li>
                                    <li>Same memories across tools</li>
                                    <li>Built for developer setups</li>
                                </ul>
                            </button>
                        </div>
                        <p class="wiz-pick-foot">You'll just need to be signed in to your chosen app.</p>

                        <div class="wiz-pick-divider"><span>already know how?</span></div>
                        <div class="mcp-quicklink">
                            <span class="mcp-quicklink-label">Just copy your LIAM link and add it as a custom
                                connector:</span>
                            <div class="mcp-quicklink-row">
                                <code>{{ mcpUrl }}</code>
                                <button type="button" (click)="copyMcpUrl()">
                                    <svg *ngIf="!mcpCopied" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" width="16" height="16">
                                        <rect x="9" y="9" width="13" height="13" rx="2" />
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>
                                    <svg *ngIf="mcpCopied" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" width="16" height="16">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    {{ mcpCopied ? 'Copied!' : 'Copy' }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Screen B: one step at a time (Claude / ChatGPT) -->
                    <div class="wiz-run"
                        *ngIf="(wizardPlatform === 'claude' || wizardPlatform === 'chatgpt' || wizardPlatform === 'muse') && !wizardDone">
                        <div class="wiz-head">
                            <button type="button" class="wiz-change" (click)="wizardReset()">← Change app</button>
                            <span class="wiz-count">Step {{ wizardIndex + 1 }} of {{ wizardTotal }} · {{ platformLabel }}</span>
                        </div>
                        <div class="wiz-progress"><i [style.width.%]="wizardProgress"></i></div>

                        <div class="wiz-step-head">
                            <span class="wiz-num">{{ wizardIndex + 1 }}</span>
                            <h3 class="wiz-title">{{ currentStep.title }}</h3>
                        </div>
                        <p class="wiz-body" [innerHTML]="currentStep.body"></p>

                        <div class="step-shot wiz-shot">
                            <img class="shot-img" [src]="currentStep.img" [alt]="currentStep.title"
                                (error)="onShotError($event)" (load)="onShotLoad($event)">
                            <div class="shot-ph">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <rect x="3" y="3" width="18" height="18" rx="2" />
                                    <circle cx="8.5" cy="8.5" r="1.5" />
                                    <path d="M21 15l-5-5L5 21" />
                                </svg>
                                <span>Screenshot for this step</span>
                            </div>
                        </div>

                        <!-- copy your link -->
                        <div class="wiz-copy" *ngIf="currentStep.showCopy">
                            <div class="wiz-copy-label">Your LIAM link</div>
                            <div class="wiz-copy-row">
                                <code>{{ mcpUrl }}</code>
                                <button type="button" (click)="copyMcpUrl()">
                                    <svg *ngIf="!mcpCopied" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" width="16" height="16">
                                        <rect x="9" y="9" width="13" height="13" rx="2" />
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>
                                    <svg *ngIf="mcpCopied" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" width="16" height="16">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    {{ mcpCopied ? 'Copied!' : 'Copy' }}
                                </button>
                            </div>
                        </div>

                        <!-- a whole message to paste, for chat-driven setups -->
                        <div class="wiz-paste" *ngIf="currentStep.pasteBlock">
                            <span class="wiz-paste-label">Paste this into the chat</span>
                            <pre class="wiz-paste-text">{{ currentStep.pasteBlock }}</pre>
                            <button type="button" class="wiz-paste-btn"
                                (click)="copyPasteBlock(currentStep.pasteBlock!)">
                                <i class="fa-solid" [ngClass]="blockCopied ? 'fa-check' : 'fa-copy'"></i>
                                {{ blockCopied ? 'Copied!' : 'Copy message' }}
                            </button>
                        </div>

                        <!-- one-click launch -->
                        <a class="launch-btn wiz-launch" *ngIf="currentStep.showLaunch" [href]="launchUrl"
                            target="_blank" rel="noopener">
                            Open in {{ platformLabel }}
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16"
                                height="16">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                <polyline points="15 3 21 3 21 9" />
                                <line x1="10" y1="14" x2="21" y2="3" />
                            </svg>
                        </a>

                        <!-- reassurance for scary screens -->
                        <div class="wiz-reassure" *ngIf="currentStep.reassure">
                            <span class="wiz-shield">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18"
                                    height="18">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                    <polyline points="9 12 11 14 15 10" />
                                </svg>
                            </span>
                            <p>{{ currentStep.reassure }}</p>
                        </div>

                        <div class="wiz-nav">
                            <button type="button" class="wiz-btn-ghost" (click)="wizardBack()"
                                [disabled]="wizardIndex === 0">Back</button>
                            <button type="button" class="wiz-btn-fill" (click)="wizardNext()">
                                {{ wizardIndex === wizardTotal - 1 ? 'I’m done →' : 'Next →' }}
                            </button>
                        </div>
                    </div>

                    <!-- Screen B2: OpenClaw (command-line guide, no screenshots) -->
                    <div class="wiz-cli" *ngIf="wizardPlatform === 'openclaw'">
                        <div class="wiz-head">
                            <button type="button" class="wiz-change" (click)="wizardReset()">← Change app</button>
                            <span class="wiz-count">OpenClaw · command line</span>
                        </div>
                        <p class="cli-intro">OpenClaw is set up from your terminal. Run these commands in order — the
                            full guide (including cloud / VM notes) is on GitHub.</p>

                        <div class="cli-step" *ngFor="let s of openclawSteps; let i = index">
                            <div class="cli-step-head">
                                <span class="cli-num">{{ i + 1 }}</span>
                                <p>{{ s.text }}</p>
                            </div>
                            <div class="cli-code">
                                <code>{{ s.code }}</code>
                                <button type="button" (click)="copyCmd(i, s.code)">
                                    <svg *ngIf="copiedCmd !== i" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" width="15" height="15">
                                        <rect x="9" y="9" width="13" height="13" rx="2" />
                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                    </svg>
                                    <svg *ngIf="copiedCmd === i" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" width="15" height="15">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    {{ copiedCmd === i ? 'Copied!' : 'Copy' }}
                                </button>
                            </div>
                        </div>

                        <p class="cli-need">You'll need <strong>both</strong> the steps above and the
                            <strong>SKILL.md</strong> file from GitHub:</p>
                        <div class="cli-links">
                            <a class="launch-btn cli-guide" [href]="openclawGuideUrl" target="_blank" rel="noopener">
                                Full guide (OPENCLAW.md)
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16"
                                    height="16">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                    <polyline points="15 3 21 3 21 9" />
                                    <line x1="10" y1="14" x2="21" y2="3" />
                                </svg>
                            </a>
                            <a class="cli-guide-alt" [href]="openclawSkillUrl" target="_blank" rel="noopener">
                                Get the SKILL.md file
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16"
                                    height="16">
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                    <polyline points="15 3 21 3 21 9" />
                                    <line x1="10" y1="14" x2="21" y2="3" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    <!-- Screen C: success -->
                    <div class="wiz-done" *ngIf="wizardDone">
                        <div class="wiz-done-badge">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" width="30"
                                height="30">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        </div>
                        <h3 class="wiz-done-h">You’re all set! 🎉</h3>
                        <p class="wiz-done-sub">LIAM is now connected to {{ platformLabel }}. Try one of these to see it
                            work:</p>
                        <div class="wiz-try-label">Tap to copy, then paste into {{ platformLabel }}</div>
                        <button type="button" class="wiz-try" *ngFor="let p of examplePrompts; let i = index"
                            (click)="copyPrompt(i, p.text)">
                            <span class="wiz-try-ico">{{ p.icon }}</span>
                            <span class="wiz-try-text">“{{ p.text }}”</span>
                            <span class="wiz-try-copied" *ngIf="copiedPrompt === i">Copied!</span>
                        </button>
                        <button type="button" class="wiz-restart" (click)="wizardReset()">+ Connect another app</button>
                    </div>

                </div>
            </section>

            <!-- Examples: you + LIAM walk through the day -->
            <section class="examples-section" id="examples">
                <div class="section-header">
                    <span class="section-label">Examples</span>
                    <h2 class="section-title">A day with <span style="color:#f97316">LIAM</span></h2>
                    <p class="section-subtitle">Just say “hey LIAM, remember this” — and it does.</p>
                </div>

                <div class="walk-scene">
                    <div class="walk-tray">
                        <span class="walk-tray-label">LIAM's memory</span>
                        <span class="walk-chip" [class.glow]="c.key === walkChipGlow" *ngFor="let c of walkChips">
                            <svg class="chip-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                [ngSwitch]="c.key">
                                <g *ngSwitchCase="'contact'">
                                    <circle cx="12" cy="8" r="4" />
                                    <path d="M4.5 20c0-3.6 3.4-6 7.5-6s7.5 2.4 7.5 6" />
                                </g>
                                <g *ngSwitchCase="'food'">
                                    <path d="M6 3v7a2.5 2.5 0 0 0 5 0V3" />
                                    <line x1="8.5" y1="10" x2="8.5" y2="21" />
                                    <path d="M17 3c-1.7 0-2.7 2-2.7 4.5S15.3 12 17 12v9" />
                                </g>
                                <g *ngSwitchCase="'receipt'">
                                    <path d="M7 3h10v18l-2-1.3-1.5 1.3L12 20.7 10.5 22 9 20.7 7 22z" />
                                    <line x1="10" y1="8" x2="14" y2="8" />
                                    <line x1="10" y1="12" x2="14" y2="12" />
                                </g>
                                <g *ngSwitchDefault>
                                    <path d="M9.5 18h5" />
                                    <path d="M10 21h4" />
                                    <path d="M12 3a6 6 0 0 0-3.5 10.9c.5.4.9 1.1.9 1.8h5.2c0-.7.4-1.4.9-1.8A6 6 0 0 0 12 3z" />
                                </g>
                            </svg>
                            <span>{{ c.text }}</span>
                        </span>
                    </div>

                    <div class="walk-note" [class.show]="walkNoteShow">{{ walkNote }}</div>

                    <div class="walk-stage">
                        <div class="walk-ground"></div>

                        <div class="walk-station" [class.is-here]="walkActive === 0" style="left:20%">
                            <div class="ws-ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                    <circle cx="12" cy="8" r="4" />
                                    <path d="M4.5 20c0-3.6 3.4-6 7.5-6s7.5 2.4 7.5 6" />
                                </svg>
                            </div>
                            <div class="ws-lbl">Meets a colleague</div>
                        </div>
                        <div class="walk-station" [class.is-here]="walkActive === 1" style="left:42%">
                            <div class="ws-ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                    <path d="M6 3v7a2.5 2.5 0 0 0 5 0V3" />
                                    <line x1="8.5" y1="10" x2="8.5" y2="21" />
                                    <path d="M17 3c-1.7 0-2.7 2-2.7 4.5S15.3 12 17 12v9" />
                                </svg>
                            </div>
                            <div class="ws-lbl">Lunch</div>
                        </div>
                        <div class="walk-station" [class.is-here]="walkActive === 2" style="left:64%">
                            <div class="ws-ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                    <path d="M6 8h12l-1 12H7z" />
                                    <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
                                </svg>
                            </div>
                            <div class="ws-lbl">Groceries</div>
                        </div>
                        <div class="walk-station" [class.is-here]="walkActive === 3" style="left:86%">
                            <div class="ws-ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                    <path d="M9.5 18h5" />
                                    <path d="M10 21h4" />
                                    <path d="M12 3a6 6 0 0 0-3.5 10.9c.5.4.9 1.1.9 1.8h5.2c0-.7.4-1.4.9-1.8A6 6 0 0 0 12 3z" />
                                </svg>
                            </div>
                            <div class="ws-lbl">An idea</div>
                        </div>

                        <div class="walk-home" [class.show]="walkHome" style="left:50%">
                            <div class="ws-ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                    <path d="M3.5 11.5 12 4l8.5 7.5" />
                                    <path d="M5.5 10.5V20h13v-9.5" />
                                </svg>
                            </div>
                            <div class="ws-lbl">Home</div>
                        </div>

                        <div class="walk-pair" [class.walking]="walkWalking" [class.no-trans]="walkNoTrans"
                            [style.left]="walkPairLeft">
                            <div class="walk-fly" *ngIf="flyShow" (animationend)="onFlyDone()">{{ flyText }}</div>
                            <div class="walk-bubble" [class.show]="walkBubbleShow" [innerHTML]="walkBubble"></div>
                            <div class="walk-answer" [class.show]="walkAnswerShow" [innerHTML]="walkAnswer"></div>
                            <div class="walk-human">
                                <svg class="walk-figure" viewBox="0 0 64 96">
                                    <g class="fig-leg fig-leg-l">
                                        <rect x="24" y="70" width="9" height="17" rx="4.5" fill="#4a4a4a"
                                            stroke="#1b1b1b" stroke-width="2" />
                                        <ellipse cx="27" cy="88" rx="7" ry="3.4" fill="#1b1b1b" />
                                    </g>
                                    <g class="fig-leg fig-leg-r">
                                        <rect x="31" y="70" width="9" height="17" rx="4.5" fill="#4a4a4a"
                                            stroke="#1b1b1b" stroke-width="2" />
                                        <ellipse cx="37" cy="88" rx="7" ry="3.4" fill="#1b1b1b" />
                                    </g>
                                    <path d="M20 48 q0-8 12-8 q12 0 12 8 l1 20 q0 6-13 6 q-13 0-13-6 z" fill="#cfcfcf"
                                        stroke="#1b1b1b" stroke-width="2.4" />
                                    <g class="fig-arm fig-arm-l">
                                        <rect x="15" y="48" width="7.5" height="19" rx="3.75" fill="#cfcfcf"
                                            stroke="#1b1b1b" stroke-width="2" />
                                        <circle cx="18.7" cy="68" r="3.6" fill="#e9e5e0" stroke="#1b1b1b"
                                            stroke-width="1.5" />
                                    </g>
                                    <g class="fig-arm fig-arm-r">
                                        <rect x="41.5" y="48" width="7.5" height="19" rx="3.75" fill="#cfcfcf"
                                            stroke="#1b1b1b" stroke-width="2" />
                                        <circle cx="45.3" cy="68" r="3.6" fill="#e9e5e0" stroke="#1b1b1b"
                                            stroke-width="1.5" />
                                    </g>
                                    <circle cx="32" cy="23" r="19" fill="#ece8e3" stroke="#1b1b1b" stroke-width="2.6" />
                                    <path d="M13 22 q1-19 19-19 q18 0 19 19 q-6-10-19-10 q-13 0-19 10z" fill="#2b2b2b" />
                                    <circle cx="25" cy="24" r="3" fill="#1b1b1b" />
                                    <circle cx="26.1" cy="23" r="1" fill="#fff" />
                                    <circle cx="39" cy="24" r="3" fill="#1b1b1b" />
                                    <circle cx="40.1" cy="23" r="1" fill="#fff" />
                                    <path d="M27 31 q5 5 10 0" fill="none" stroke="#1b1b1b" stroke-width="2.2"
                                        stroke-linecap="round" />
                                </svg>
                            </div>
                            <div class="walk-liam" [class.catch]="liamCatch" (animationend)="liamCatch = false">
                                <div class="wl-ant"><span></span></div>
                                <div class="wl-head">
                                    <div class="wl-eye l"></div>
                                    <div class="wl-eye r"></div>
                                    <div class="wl-smile"></div>
                                </div>
                                <div class="wl-body">L</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="walk-dots">
                    <i *ngFor="let s of walkSteps; let k = index" [class.on]="k === walkActive"></i>
                </div>
            </section>

            <!-- Who We Are Section -->
            <section class="about-section">
                <div class="about-card">
                    <div class="about-header">
                        <svg class="about-icon" viewBox="0 0 32 32" fill="none">
                            <rect x="4" y="8" width="24" height="18" rx="2" stroke="#f97316" stroke-width="2" />
                            <rect x="8" y="4" width="16" height="6" rx="1" stroke="#f97316" stroke-width="2" />
                            <line x1="10" y1="14" x2="22" y2="14" stroke="#f97316" stroke-width="1.5" opacity="0.5" />
                            <line x1="10" y1="18" x2="18" y2="18" stroke="#f97316" stroke-width="1.5" opacity="0.5" />
                            <line x1="10" y1="22" x2="20" y2="22" stroke="#f97316" stroke-width="1.5" opacity="0.5" />
                        </svg>
                        <h3>Who We Are</h3>
                    </div>
                    <div class="about-content">
                        <p>NetXD is a financial technology company that powers banks and institutions globally with
                            cutting-edge solutions for transaction banking, embedded finance, and blockchain
                            infrastructure. LIAM brings this same innovation to personal and team productivity,
                            offering an AI-powered knowledge management platform that helps you store, organize, and
                            recall everything that matters.</p>
                    </div>
                    <div class="about-cta">
                        <div class="cta-text">
                            <h4>Learn More About NetXD</h4>
                            <p>Discover how we're transforming enterprise operations and personal productivity.</p>
                        </div>
                        <a href="https://netxd.com/#/home" target="_blank" class="btn-outline">Visit Our Website <svg
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                <polyline points="15 3 21 3 21 9" />
                                <line x1="10" y1="14" x2="21" y2="3" />
                            </svg></a>
                    </div>
                </div>
            </section>

            <!-- Quick Links Section -->
            <section class="quicklinks-section">
                <div class="section-header">
                    <span class="section-label">Get Started</span>
                    <h2 class="section-title"><svg viewBox="0 0 24 24" fill="none"
                            style="width:28px;height:28px;vertical-align:middle;margin-right:8px;">
                            <path d="M12 4l-1 8h6l-7 8 1-8H5l7-8z" stroke="#f97316" stroke-width="2"
                                stroke-linejoin="round" />
                        </svg>Setup Guides</h2>
                </div>
                <div class="quicklinks-grid">
                    <a class="quicklink-card" (click)="openGuide('mcp')" href="javascript:void(0)">
                        <svg class="ql-icon" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="9" width="7" height="6" rx="1" stroke="#f97316" stroke-width="1.5" />
                            <rect x="14" y="9" width="7" height="6" rx="1" stroke="#f97316" stroke-width="1.5" />
                            <line x1="10" y1="12" x2="14" y2="12" stroke="#f97316" stroke-width="1.5" />
                            <circle cx="6.5" cy="5" r="1.5" fill="#f97316" opacity="0.5" />
                            <circle cx="17.5" cy="5" r="1.5" fill="#f97316" opacity="0.5" />
                        </svg>
                        <span class="ql-title">Claude AI Connector</span>
                        <svg class="ql-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                    <a class="quicklink-card" [href]="chatgptAppUrl" target="_blank" rel="noopener noreferrer">
                        <svg class="ql-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M4 6h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9l-4 4v-4H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z"
                                stroke="#f97316" stroke-width="1.5" stroke-linejoin="round" />
                            <circle cx="9" cy="11" r="1" fill="#f97316" />
                            <circle cx="12" cy="11" r="1" fill="#f97316" />
                            <circle cx="15" cy="11" r="1" fill="#f97316" />
                        </svg>
                        <span class="ql-title">LIAM in ChatGPT</span>
                        <svg class="ql-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                    <a class="quicklink-card" (click)="openGuide('perplexity')" href="javascript:void(0)">
                        <svg class="ql-icon" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="8" stroke="#f97316" stroke-width="1.5" />
                            <circle cx="12" cy="12" r="3" stroke="#f97316" stroke-width="1.5" />
                            <line x1="12" y1="4" x2="12" y2="9" stroke="#f97316" stroke-width="1" opacity="0.4" />
                        </svg>
                        <span class="ql-title">Perplexity Connector</span>
                        <svg class="ql-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                    <a class="quicklink-card" (click)="openGuide('chrome')" href="javascript:void(0)">
                        <svg class="ql-icon" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="4" width="18" height="14" rx="2" stroke="#f97316" stroke-width="1.5" />
                            <line x1="3" y1="20" x2="21" y2="20" stroke="#f97316" stroke-width="1.5"
                                stroke-linecap="round" />
                            <line x1="7" y1="8" x2="10" y2="8" stroke="#f97316" stroke-width="1.5"
                                stroke-linecap="round" />
                            <line x1="7" y1="11" x2="14" y2="11" stroke="#f97316" stroke-width="1.5"
                                stroke-linecap="round" />
                        </svg>
                        <span class="ql-title">Chrome Extension</span>
                        <svg class="ql-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                    <a class="quicklink-card" (click)="openGuide('tools')" href="javascript:void(0)">
                        <svg class="ql-icon" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"
                                stroke="#f97316" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="ql-title">API Tools Guide</span>
                        <svg class="ql-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M5 12h14M12 5l7 7-7 7" />
                        </svg>
                    </a>
                </div>
            </section>

            <!-- Scrolling Connectors Ticker -->
            <section class="connectors-ticker">
                <div class="ticker-label">
                    <span>Available Connectors</span>
                </div>
                <div class="ticker-wrapper">
                    <div class="ticker-track">
                        <!-- First set of connectors -->
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#d97706" stroke-width="2">
                                <rect x="4" y="4" width="32" height="32" rx="8" />
                                <circle cx="14" cy="16" r="2.5" fill="#d97706" />
                                <circle cx="26" cy="16" r="2.5" fill="#d97706" />
                                <path d="M14 26c3 3 9 3 12 0" />
                            </svg>
                            <span>Claude AI</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#10a37f" stroke-width="2">
                                <path
                                    d="M8 10h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H16l-6 6v-6H8a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2z" />
                                <circle cx="15" cy="19" r="1.6" fill="#10a37f" />
                                <circle cx="20" cy="19" r="1.6" fill="#10a37f" />
                                <circle cx="25" cy="19" r="1.6" fill="#10a37f" />
                            </svg>
                            <span>ChatGPT</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#22d3ee" stroke-width="2">
                                <circle cx="20" cy="20" r="14" />
                                <circle cx="20" cy="20" r="6" />
                            </svg>
                            <span>Perplexity</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#10b981" stroke-width="2">
                                <rect x="4" y="8" width="32" height="24" rx="3" />
                                <path d="M4 16h32M12 8v8M28 8v8" />
                            </svg>
                            <span>Google Chrome</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#f97316" stroke-width="2">
                                <rect x="4" y="4" width="32" height="32" rx="4" />
                                <circle cx="20" cy="15" r="5" />
                                <path d="M10 34c0-5 4.5-8 10-8s10 3 10 8" />
                            </svg>
                            <span>AskBuddy</span>
                        </div>
                        <!-- Duplicate set for seamless loop -->
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#d97706" stroke-width="2">
                                <rect x="4" y="4" width="32" height="32" rx="8" />
                                <circle cx="14" cy="16" r="2.5" fill="#d97706" />
                                <circle cx="26" cy="16" r="2.5" fill="#d97706" />
                                <path d="M14 26c3 3 9 3 12 0" />
                            </svg>
                            <span>Claude AI</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#10a37f" stroke-width="2">
                                <path
                                    d="M8 10h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H16l-6 6v-6H8a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2z" />
                                <circle cx="15" cy="19" r="1.6" fill="#10a37f" />
                                <circle cx="20" cy="19" r="1.6" fill="#10a37f" />
                                <circle cx="25" cy="19" r="1.6" fill="#10a37f" />
                            </svg>
                            <span>ChatGPT</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#22d3ee" stroke-width="2">
                                <circle cx="20" cy="20" r="14" />
                                <circle cx="20" cy="20" r="6" />
                            </svg>
                            <span>Perplexity</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#10b981" stroke-width="2">
                                <rect x="4" y="8" width="32" height="24" rx="3" />
                                <path d="M4 16h32M12 8v8M28 8v8" />
                            </svg>
                            <span>Google Chrome</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#f97316" stroke-width="2">
                                <rect x="4" y="4" width="32" height="32" rx="4" />
                                <circle cx="20" cy="15" r="5" />
                                <path d="M10 34c0-5 4.5-8 10-8s10 3 10 8" />
                            </svg>
                            <span>AskBuddy</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#d97706" stroke-width="2">
                                <rect x="4" y="4" width="32" height="32" rx="8" />
                                <circle cx="14" cy="16" r="2.5" fill="#d97706" />
                                <circle cx="26" cy="16" r="2.5" fill="#d97706" />
                                <path d="M14 26c3 3 9 3 12 0" />
                            </svg>
                            <span>Claude AI</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#10a37f" stroke-width="2">
                                <path
                                    d="M8 10h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H16l-6 6v-6H8a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2z" />
                                <circle cx="15" cy="19" r="1.6" fill="#10a37f" />
                                <circle cx="20" cy="19" r="1.6" fill="#10a37f" />
                                <circle cx="25" cy="19" r="1.6" fill="#10a37f" />
                            </svg>
                            <span>ChatGPT</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#22d3ee" stroke-width="2">
                                <circle cx="20" cy="20" r="14" />
                                <circle cx="20" cy="20" r="6" />
                            </svg>
                            <span>Perplexity</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#10b981" stroke-width="2">
                                <rect x="4" y="8" width="32" height="24" rx="3" />
                                <path d="M4 16h32M12 8v8M28 8v8" />
                            </svg>
                            <span>Google Chrome</span>
                        </div>
                        <div class="ticker-item">
                            <svg viewBox="0 0 40 40" fill="none" stroke="#f97316" stroke-width="2">
                                <rect x="4" y="4" width="32" height="32" rx="4" />
                                <circle cx="20" cy="15" r="5" />
                                <path d="M10 34c0-5 4.5-8 10-8s10 3 10 8" />
                            </svg>
                            <span>AskBuddy</span>
                        </div>
                    </div>
                </div>
                <div class="ticker-label ticker-label-right">
                    <span>& More Coming Soon</span>
                </div>
            </section>

            <!-- Footer -->
            <footer class="footer">
                <div class="footer-content">
                    <div class="footer-brand">
                        <svg width="32" height="32" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="80" height="80" rx="18" fill="#f97316" />
                            <path d="M25 18V62H55" stroke="white" stroke-width="6" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="25" cy="18" r="5" fill="white" />
                            <circle cx="55" cy="62" r="5" fill="white" />
                            <circle cx="40" cy="62" r="3" fill="white" opacity="0.6" />
                            <circle cx="25" cy="40" r="3" fill="white" opacity="0.6" />
                        </svg>
                    </div>
                    <p>Powered by <a href="https://netxd.com/#/home" target="_blank">NetXD</a></p>
                </div>
            </footer>

        </form>
    </div>

    <!-- OTP Verification View -->
    <div class="otp-content" *ngIf="otpNav">
        <div class="otp-card">
            <button class="back-btn" (click)="otpNav = false" type="button">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
                Back
            </button>

            <div class="otp-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                </svg>
            </div>

            <h2>Check your email</h2>
            <p class="otp-subtitle">We sent a 6-digit code to<br><strong>{{emailId}}</strong></p>

            <ng-otp-input class="otp-input" (onInputChange)="onOtpChange($event)"
                [config]="{ length: 6, allowNumbersOnly: true }" (keydown.enter)="loginWithOtp()"></ng-otp-input>

            <button class="btn-primary" type="button" (click)="loginWithOtp()">
                <span>Verify & Continue</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
            </button>

            <div class="resend-row">
                <span>Didn't receive the code?</span>
                <button *ngIf="!resendEnabled" class="resend-btn disabled" type="button" disabled>Resend in {{ countDown
                    }}s</button>
                <button *ngIf="resendEnabled" class="resend-btn" type="button" (click)="onResend()">Resend Code</button>
            </div>
        </div>
    </div>
</div>